import React, { useEffect, useState } from 'react';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput';
import { Button } from 'flowbite-react';
import icon from '../../../assets/Featured icon (2).png';
import { useCurrency } from '../../../contexts/CurrencyContext';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';

interface NewPaymentLink {
    name: string;
    description: string;
    paymentType: string;
    amount?: number | null;
    mobile?: string;
    currency: string;
    limit?: number | null;
}

interface PaymentModalContentProps{
    close:()=>void,
    onLinkAdded:()=>void
}

const PaymentModalContent = ({close,onLinkAdded}:PaymentModalContentProps) => {
    const [paymentTypes, setPaymentTypes] = useState<any[]>([]);
    const { availableCurrencies } = useCurrency();

    const [inputs, setInputs] = useState<NewPaymentLink>({
        name: '',
        description: '',
        paymentType: '',
        amount: null,
        limit: null,
        currency: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            await getPaymentTypes();
        };

        fetchData();
    }, []);

    const getPaymentTypes = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/payment/link/types');

            setPaymentTypes(response.data.paymentLinkTypes);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const handleInputChange = (name: string, value: any) => {
        setInputs((prevInputs) => ({
            ...prevInputs,
            [name]: value,
        }));
    };

    const createNewLink = async () => {
        const payload: NewPaymentLink = {
            name: inputs.name,
            description: inputs.description,
            currency: inputs.currency,
            paymentType: inputs.paymentType,
            limit: inputs.limit,
            amount: inputs.amount,
        }

        try {
            const response = await client.post('/subsidiary/dashboard/payment/link/new', payload);

            const message = response?.data?.message;
            showToast(message, "success")
            onLinkAdded()
            close()

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }

    return (
        <div className='py-4'>
            <div>
                <img src={icon} className='my-3' alt='Icon' />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Create Payment Link</p>
                    <p className='text-sm'>Kindly fill in information needed</p>
                </div>
            </div>
            <CustomInput
                label='Link Name'
                name='name'
                value={inputs.name}
                onChange={(e) => handleInputChange('name', e.target.value)}
            />
            <CustomInput
                label='Description'
                name='description'
                value={inputs.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
            />
            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 items-center justify-center'>
                <CustomSelectInput
                    className='text-sm font-semibold'
                    label='Payment type'
                    items={paymentTypes || []}
                    displayKey='paymentLinkName'
                    valueKey='code'
                    value={inputs.paymentType}
                    onChange={(value) => handleInputChange('paymentType', value)}
                />
                <CustomSelectInput
                    className='text-sm font-semibold'
                    label='Currency'
                    items={availableCurrencies}
                    displayKey='name'
                    valueKey='shortName'
                    value={inputs.currency}
                    onChange={(value) => handleInputChange('currency', value)}
                />
                <CustomInput
                    className='text-sm'
                    name='amount'
                    label='Amount'
                    type='number'
                    value={inputs.amount?.toString()}
                    onChange={(e) => handleInputChange('amount', parseFloat(e.target.value))}
                />
                <CustomInput
                    className='text-sm'
                    label='Limit'
                    name='limit'
                    type='number'
                    value={inputs.limit?.toString()}
                    onChange={(e) => handleInputChange('limit', parseFloat(e.target.value))}
                />
            </div>
            <div className='flex gap-3 my-4'>
                <Button className='w-1/4 ring-gray-400' outline onClick={close}>Cancel</Button>
                <Button className='w-3/4 bg-custom-button-green' onClick={() => createNewLink()}>Create New Link</Button>
            </div>
        </div>
    );
};

export default PaymentModalContent;
